// extracted by mini-css-extract-plugin
module.exports = {"v1el5j4g":"v1el5j4g","h1du70pe":"h1du70pe"};